import { Component, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { LanguageProvider } from "@/context/language";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Services from "./components/Services";
import TiSection from "./components/TiSection";
import Spda3D from "./components/Spda3D";
import Gallery from "./components/Gallery";
import Coverage from "./components/Coverage";
import Team from "./components/Team";
import Testimonials from "./components/Testimonials";
import QuoteBuilder from "./components/QuoteBuilder";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-obsidian text-white p-8 text-center">
                    <div>
                        <p className="font-display font-bold text-2xl">ANG</p>
                        <p className="mt-3 text-slate-400 text-sm">
                            Recarregue a página para continuar.
                        </p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

function ScrollManager() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        let lenis;
        let raf;
        let cancelled = false;
        import("lenis")
            .then(({ default: Lenis }) => {
                if (cancelled) return;
                lenis = new Lenis({ duration: 1.15, smoothWheel: true });
                window.__lenis = lenis;
                const loop = (time) => {
                    lenis.raf(time);
                    raf = requestAnimationFrame(loop);
                };
                raf = requestAnimationFrame(loop);
            })
            .catch(() => {});
        return () => {
            cancelled = true;
            if (raf) cancelAnimationFrame(raf);
            if (lenis) lenis.destroy();
            window.__lenis = null;
        };
    }, []);
    return null;
}

export default function App() {
    return (
        <LanguageProvider>
            <BrowserRouter>
                <ErrorBoundary>
                    <ScrollManager />
                    <div className="noise-overlay" aria-hidden />
                    <Navbar />
                    <main>
                        <Hero />
                        <Marquee />
                        <Services />
                        <TiSection />
                        <Spda3D />
                        <Gallery />
                        <Coverage />
                        <Team />
                        <Testimonials />
                        <QuoteBuilder />
                        <Footer />
                    </main>
                    <FloatingWhatsApp />
                </ErrorBoundary>
            </BrowserRouter>
        </LanguageProvider>
    );
}
